import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Layout from '../components/layout'
import blogStyles from '../pages/blog.module.scss'
import BlogTag from '../components/blogtag'
import Search from '../components/searchcontainer'
const BlogPage = () => {
    const data = useStaticQuery(graphql`
        query {
            allMarkdownRemark {
                edges {
                    node {
                        frontmatter {
                            title
                            date(formatString: "YYYY, MMMM DD")
                            tags
                        }
                        fields {
                            slug
                        }
                    }
                }
            }
        }
    `)
    return (
        <Layout>
            <h1>Blog</h1>
            <div className={blogStyles.container}>

            <ol>
                {data.allMarkdownRemark.edges.map((edge) => {
                    return (
                        <li className={blogStyles.blog}>
                            <Link to={`/blog/${edge.node.fields.slug}`} className={blogStyles.title} activeClassName={blogStyles.activeTitle}>
                                <h2>{edge.node.frontmatter.title}</h2>
                            </Link>
                            <p>{edge.node.frontmatter.date}</p>
                            <BlogTag tags={edge.node.frontmatter.tags}></BlogTag>
                        </li>
                    )
                })}
            </ol>

            <Search/>
                </div>
        </Layout>

    )
}
export default BlogPage